import { render, staticRenderFns } from "./HorizontalLoader.vue?vue&type=template&id=fc8ba314&scoped=true"
var script = {}
import style0 from "./HorizontalLoader.vue?vue&type=style&index=0&id=fc8ba314&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc8ba314",
  null
  
)

export default component.exports